import React from "react"
import { Grid, Button } from "semantic-ui-react"

export class AskSpouseIncome extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      succeeded: false,
      cancelled: false
    }
  }
  onSuccess = async () => {
    const {
      household: { id },
      updateHousehold
    } = this.props
    await updateHousehold({ id, has_confirmed_incomes: true })
    this.setState({ succeeded: true })
  }
  onCancel = async () => {
    const {
      household: { id },
      updateHousehold
    } = this.props
    await updateHousehold({ id, has_confirmed_incomes: true })
    this.setState({ cancelled: true })
  }
  render = () => {
    if (this.state.cancelled) {
      return this.props.onCancel()
    }
    if (this.state.succeeded) {
      return this.props.onSuccess()
    }
    return (
      <Grid
        centered
        container
        style={{ paddingTop: "4em", paddingBottom: "8em" }}
      >
        <Grid.Row style={{ paddingBottom: "0" }}>
          <Grid.Column
            textAlign="center"
            style={{ fontSize: "2.5em", fontWeight: "300" }}
          >
            <p>Does your spouse earn income?</p>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column
            className="IncomeEmptyState__Description"
            width={14}
            textAlign="center"
          >
            {this.props.isCOVID ? (
              <p>
                If your spouse is currently furloughed, unemployed or has
                reduced hours, please enter what you expect your spouse to earn
                when things are back to normal.
              </p>
            ) : null}
          </Grid.Column>
        </Grid.Row>
        <Grid.Row
          columns="2"
          style={{ paddingTop: "4em", paddingBottom: "3em" }}
        >
          <Grid.Column textAlign="right">
            <Button
              basic
              primary
              content="No"
              data-testid="no"
              type="button"
              onClick={() => this.onCancel()}
            />
          </Grid.Column>
          <Grid.Column>
            <Button
              primary
              content="Yes"
              data-testid="yes"
              type="button"
              onClick={() => this.onSuccess()}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    )
  }
}
